/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';

const TASK_STATUS = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export default class BackgroundTaskChangeHandlerComponent extends Component {
  @service apolloSubscriptions;
  @service eventPropagator;

  taskId = null;

  constructor() {
    super(...arguments);
    this.eventPropagator.subscribe('backgroundTaskChange', this.onChangeCb);
    registerDestructor(this, () => {
      this.cleanUpApolloSubscription();
      this.eventPropagator.unsubscribe('backgroundTaskChange', this.onChangeCb);
      if (typeof this.args.onDestroy === 'function') {
        this.args.onDestroy();
      }
    });
  }

  @action
  subscribe(taskId) {
    if (this.taskId) {
      this.cleanUpApolloSubscription();
    }
    if (taskId) {
      this.taskId = taskId;
      this.apolloSubscriptions.subscribe('backgroundTaskChange', { taskId });
    }
  }

  @action
  onChangeCb(resource) {
    if (resource.id === this.taskId) {
      if (
        resource.status === TASK_STATUS.COMPLETED &&
        typeof this.args.onComplete === 'function'
      ) {
        this.args.onComplete(resource);
      } else if (
        resource.status === TASK_STATUS.FAILED &&
        typeof this.args.onFail === 'function'
      ) {
        this.args.onFail(resource);
      }
      this.cleanUpApolloSubscription();
    }
  }

  @action
  cleanUpApolloSubscription() {
    if (this.taskId) {
      this.apolloSubscriptions.unsubscribe('backgroundTaskChange', {
        taskId: this.taskId,
      });
      this.taskId = null;
    }
  }
}
